import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { UploadCSRCService } from "../../../shared/services/upload-csrc/upload-csrc.service";
import { Router } from "@angular/router";
import { AlertService } from "../../../shared/services/alert/alert.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-upload-csrc",
  templateUrl: "./upload-csrc.component.html",
  styleUrls: ["./upload-csrc.component.scss"]
})
export class UploadCSRCComponent implements OnInit {
  fileType: any =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataAvailable = false;
  dataCount: any;
  uploadType: any = "import";
  error: any;
  private _error = new Subject<string>();
  errorMessage = null;
  successMessage = null;
  uploadcrscdata: any;
  sender = "upload-csrc";
  errorOnly = false;
  errorCount = 0;
  showAll = true;

  constructor(
    private router: Router,
    private uploadCSRCService: UploadCSRCService,
    private alertService: AlertService
  ) {}

  ngOnInit() {}

  ondocImport(e) {
    this.uploadcrscdata = e;

    this.errorCount = 0;

    for (var i = 0; i < this.uploadcrscdata.length; i++) {
      if (this.uploadcrscdata[i].errors.length > 0) {
        this.errorCount += 1;
        this.alertService.err(this.sender, this.uploadcrscdata[i].errors);
      }
    }

    if (this.uploadcrscdata.length > 0) {
      this.dataAvailable = true;
      this.dataCount = this.uploadcrscdata.length;
    } else {
      this._error.next("Data not found!!");
    }
  }

  getData() {
    var data = [];

    if (!this.uploadcrscdata) {
      return data;
    }

    if (this.showAll) {
      return this.uploadcrscdata;
    }
    for (var i = 0; i < this.uploadcrscdata.length; i++) {
      var d = this.uploadcrscdata[i];
      if (this.errorOnly && d.errors.length > 0) {
        data.push(d);
      } else if (!this.errorOnly && d.errors.length == 0) {
        data.push(d);
      }
    }

    return data;
  }

  onConfirm() {
    this.uploadCSRCService
      .saveImportCRSC(this.uploadcrscdata)
      .pipe(first())
      .subscribe(res => {
        this.dataAvailable = false;

        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "csrc Data Saved");
        this.router.navigate(["manager/csrc"]);
      });
  }

  ondocError(e) {
    this.error = e;
  }
}
